import React, { useEffect, useState } from "react";
import SelectComponent from "../../../ReusableComponents/SelectComponent";
import TotalAcreageGraph from "../../Acreage/SubComponents/TotalAcreageGraph";
import Popup from "../../../ReusableFunctions/Popup";
import { getAllCrops } from "../../../apis/crops";
import { getRevenueGraphData } from "../../../apis/revenue";
import { formatAmountWithSymbol } from "../../../ReusableFunctions/reusableFunctions";
import { getAcreageGraphData } from "../../../apis/acreage";
export default function CropAcreage({ fromDate, toDate, interval, user }) {
  const [crops, setCrops] = useState([]);
  const [selectedCrop, setSelectedCrop] = useState({
    label: "All",
    value: "All",
  });
  const [loading, setLoading] = useState(false);
  const [revenueData, setRevenueData] = useState([]);
  const unit=user?.dsp?.settings?.units
  const getCropsFunc = async () => {
    try {
      const { crops } = await getAllCrops();
      setCrops(crops);
      if (crops && crops.length > 0) {
        setSelectedCrop({
          label: crops[0].name,
          value: crops[0].name,
        });
      }
    } catch (e) {
      Popup.alert("Error", e, "ERROR");
    }
  };

  const fetchAcreageData = async () => {
    try {
      setLoading(true);
      const data = await getAcreageGraphData({
        fromDate: fromDate?.toISOString(),
        toDate: toDate?.toISOString(),
        interval: interval?.toLowerCase(),
        cropName: selectedCrop?.value,
      });
      setRevenueData(data);
      setLoading(false);
    } catch (err) {
      Popup.alert(
        "Crops",
        "Something Went wrong while getting crops !",
        "ERROR",
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    getCropsFunc();
  }, []);

  useEffect(() => {
    fetchAcreageData();
  }, [interval, selectedCrop?.value]);

  return (
    <div className="">
      <div
        className=""
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingBottom: "2px",
        }}
      >
        <div>
          <span style={{ fontSize: "18px", fontWeight: 700 }}>
            Crop {unit==="Acre"?"Acreage":"Hectarage"} -{" "}
          </span>
          <span style={{ fontSize: "20px", color: "blue", fontWeight: 700 }}>
            {Number(revenueData?.[0]?.total_acreage || 0).toFixed(2)}  {user?.dsp?.settings?.units}
          </span>
        </div>
        <div>
          <SelectComponent
            controlStyle={{
              height: "30px",
              width: "200px",
              minHeight: "20px",
              border: "none",
              boxShadow: "0px 2px 5px 1px #6273943d",
              color: "hsl(0deg 0% 20% / 64%)",
              fontSize: "10px",
            }}
            menuStyles={{
              zIndex: "1000",
            }}
            isSearchable={true}
            placeholder={"Select crop..."}
            menuPlacement={"bottom"}
            list={[...crops.map((p) => ({ label: p.name, value: p.name }))]}
            value={
              selectedCrop.label
                ? { value: selectedCrop.value, label: selectedCrop.label }
                : ""
            }
            onChange={(e) => {
              setSelectedCrop({
                label: e.label,
                value: e.value,
              });
            }}
          />
        </div>
      </div>

      <TotalAcreageGraph
        showZoom={true}
        interval={interval}
        title={"total Revenue "}
        lineType={2}
        loading={loading}
        data={revenueData}
      />
    </div>
  );
}
